import React from 'react';
import {useHubspotContactPropertyDefinitionsQuery} from 'api';
import {hubspotContactValueLabel} from '../../hubspotContactValue';
import useCondition from '../../useCondition';

type HubspotContactCheckboxSearchCondition = {
  field_type?: string;
  hubspot_contact_property_definition_id?: string;
  value?: string;
};

export default () => {
  const {condition, poolId, canUseHubspotContactFilter} = useCondition();

  const {data: {hubspotContactPropertyDefinitions = []} = {}} =
    useHubspotContactPropertyDefinitionsQuery({
      variables: {poolId},
      skip: !poolId,
    });

  // 条件が 1 件でもあれば表示する。項目だけ選んで値が未設定の条件を
  // 表示から落とすと、追加メニュー側は設定済み扱いで選択肢が消えるのに
  // 一覧には出ないため、編集も削除もできない状態になる。
  const searchConditions: HubspotContactCheckboxSearchCondition[] =
    condition?.hubspotContactSearchConditions ?? [];

  if (!canUseHubspotContactFilter || searchConditions.length === 0) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">コンタクト</h4>
      </div>
      {searchConditions.map((searchCondition, index) => {
        const property = hubspotContactPropertyDefinitions.find(
          (item) =>
            item.id === searchCondition.hubspot_contact_property_definition_id,
        );

        return (
          <div className="flex gap-2" key={index}>
            <span className="text-c-light h-6 flex items-center">
              {property?.labelText || property?.name || '項目未選択'}：
            </span>
            <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              {hubspotContactValueLabel(property, searchCondition.value)}
            </span>
          </div>
        );
      })}
    </div>
  );
};
